import React from 'react';
import styled from 'styled-components';

const TreeMarker = (props) => {

  const { selectedTree, isSelected, ...otherProps } = props;

  const TreeMarkerButton = styled.button`
    display: block;
    width: 40px;
    height: 40px;
    padding: 8px;
    margin: 0;
    background: none;
    border: 0;
    border-radius: 20px;
    cursor: pointer;

    ${isSelected ? `
      background: #fff;
    ` : ''}

    /* ${selectedTree && !isSelected ? `
      opacity: 0.25;
      background: #fff;
    ` : ''} */

    > svg {
      display: block;
      width: 100%;
      height: 100%;
      /* fill: #e94858; */
    }

  `;

  return (
    <TreeMarkerButton {...otherProps}>
      <svg viewBox="0 0 512 512">
        <path fill="#FFFFFF" d="M256,18.6c32.8,0,60.4,22.1,68.8,52.2c9.5-4.6,20.1-7.2,31.3-7.2c39.5,0,71.5,32,71.5,71.5 c0,11.8-2.9,23-8,32.8c28.8,12.2,49,40.6,49,73.9c0,43-33.9,78.1-76.5,80c-5.9,21.5-28.8,37.5-56.2,37.5c-15.5,0-29.6-5.2-40-13.5 c-0.1,0.1-0.2,0.2-0.3,0.3l-3.9,6.2c-5.7,8.9-8.2,19.5-7.3,30c3.6,41.1,10.2,80,37.1,111.3h-131c25.1-29.3,31.2-65.2,36.2-103.3 c1.4-10.6-0.9-21.4-6.4-30.6l-7.1-11.8c-10,7.1-23,11.4-37.1,11.4c-27.4,0-50.3-16-56.2-37.5c-42.6-1.9-76.5-37-76.5-80 c0-33.2,20.2-61.7,49-73.9c-5.1-9.8-8-21-8-32.8c0-39.5,32-71.5,71.5-71.5c11.2,0,21.9,2.6,31.3,7.2 C195.6,40.7,223.2,18.6,256,18.6 M256,0c-20.1,0-39,6.5-54.9,18.7c-10.1,7.8-18.4,17.6-24.4,28.7c-6.8-1.6-13.8-2.4-20.9-2.4 c-49.6,0-90,40.4-90,90c0,8.2,1.1,16.4,3.3,24.2c-27.4,18-44.3,48.8-44.3,82.4c0,25.6,9.7,49.8,27.4,68.3 c14.8,15.4,33.8,25.5,54.6,29c12.2,23.4,39,38.8,69.3,38.8c10.3,0,20.6-1.9,30-5.4c2.1,4.8,2.9,10.2,2.3,15.5 c-4.7,36.4-10.4,68.5-31.9,93.6L150.2,512h40.4h131h40.4l-26.3-30.6C325,469,317.3,454.3,312,436.3c-5.4-18.5-7.6-38.6-9.1-55.7 c-0.3-3.1,0-6.1,0.6-9.1c10,4.1,21.1,6.3,32.4,6.3c30.3,0,57-15.5,69.3-38.8c20.7-3.5,39.8-13.6,54.6-29 c17.7-18.4,27.4-42.7,27.4-68.3c0-33.6-16.9-64.4-44.3-82.4c2.2-7.9,3.3-16,3.3-24.2c0-49.6-40.4-90-90-90 c-7.1,0-14.1,0.8-20.9,2.4c-6-11.1-14.3-21-24.4-28.7C295,6.5,276.1,0,256,0L256,0z" />
        <path fill="#129B12" d="M468.7,241.7c0-33.2-20.2-61.7-49-73.9c5.1-9.8,8-21,8-32.8c0-39.5-32-71.5-71.5-71.5 c-11.2,0-21.9,2.6-31.3,7.2c-8.4-30.1-36-52.2-68.8-52.2s-60.4,22.1-68.8,52.2c-9.5-4.6-20.1-7.2-31.3-7.2 c-39.5,0-71.5,32-71.5,71.5c0,11.8,2.9,23,8,32.8c-28.8,12.2-49,40.6-49,73.9c0,43,33.9,78.1,76.5,80 c5.9,21.5,28.8,37.5,56.2,37.5c15.5,0,29.6-5.2,40-13.5c10.4,8.4,24.5,13.5,40,13.5c15.5,0,29.6-5.2,40-13.5 c10.4,8.4,24.5,13.5,40,13.5c27.4,0,50.3-16,56.2-37.5C434.7,319.7,468.7,284.7,468.7,241.7z" />
        <path fill="#BF6101" d="M291.7,352.1l30.6-48.3c2.4-3.8,1.7-8.8-1.7-11.8l0,0c-3.6-3.2-9.1-3-12.5,0.5l-22.6,22.8 c-3,3-8.1,0.5-7.5-3.7l6.6-49.1c0.7-5.2-3.2-10-8.5-10.4l-6.2-0.4c-4.7-0.3-8.8,2.9-9.6,7.5l-11.8,67.3c-0.7,3.7-5.4,5-7.8,2 l-37.1-45.6c-2.6-3.2-6.9-4.2-10.7-2.7l-6.5,2.7c-5.1,2.2-7.2,8.4-4.3,13.2l38.1,63.5c5.5,9.2,7.8,20,6.4,30.6 c-4.9,38.1-11.1,74-36.2,103.3h131l0,0c-26.9-31.3-33.5-70.3-37.1-111.3C283.5,371.6,286.1,361,291.7,352.1z" />
      </svg>
      {/* <svg viewBox="0 0 54.757 54.757">
        <path d="M40.94,5.617C37.318,1.995,32.502,0,27.38,0c-5.123,0-9.938,1.995-13.56,5.617c-6.703,6.702-7.536,19.312-1.804,26.952 L27.38,54.757L42.721,32.6C48.476,24.929,47.643,12.319,40.94,5.617z M27.557,26c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7 S31.416,26,27.557,26z" />
      </svg> */}
    </TreeMarkerButton>
  );
};

export default TreeMarker;
